import { isServerSide } from './isServerSide';

declare global {
    // eslint-disable-next-line no-var
    var Cypress: boolean | undefined;
    // eslint-disable-next-line no-var
    var CypressEnableDownloads: boolean | undefined;
}
export const areIntegrationTestsRunning = () => !isServerSide() && !!globalThis.Cypress;
